import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

//import lib
import { toastAlert } from "../../lib/toastAlert";
import isEmpty from "../../lib/isEmpty";

//import api
import { getSptCat, createNewTicket } from "../../api/support";

//import validation
import validation from "./validation";

const initialFormValue = {
    categoryId: "",
    message: "",
    image: {},
};
let imageType = ['jpg', 'JPG', 'jpeg', 'JPEG', 'png', 'PNG', 'pdf', 'PDF']
const CreateTicket = () => {

    const { t, i18n } = useTranslation()


    //state
    const [categoryList, setCategoryList] = useState([]);
    const [formValue, setFormValue] = useState(initialFormValue);
    const [loader, setLoader] = useState();
    const [validateError, setValidateError] = useState({});
    const { categoryId, message, image } = formValue;

    // function
    const handleChange = (e) => {
        e.preventDefault();
        const { name, value } = e.target;
        let formData = { ...formValue, ...{ [name]: value } };
        setFormValue(formData);
        if (!isEmpty(validateError)) {
            setValidateError({});
        }
    };

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        if (!imageType.includes(files[0].type.split('/')[1])) {
            return toastAlert("error", t('UPLOAD_SIZE_RESTRICT'), "updateProfile");

        }
        if (files[0]?.size >= 1000000) {
            return toastAlert("error", t("UPLOAD_ERROR"), "updateProfile");
        }
        let formData = { ...formValue, ...{ [name]: files[0] } };
        setFormValue(formData);
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        let reqData = {
            categoryId,
            message,
            image,
        };
        let validationError = validation(reqData, "createTicket");
        if (!isEmpty(validationError)) {
            setValidateError(validationError);
            setLoader(false);
            return;
        }
        let formData = new FormData();
        formData.append("categoryId", categoryId);
        formData.append("message", message);
        formData.append("image", image);
        setLoader(true);
        try {
            const { status, loading, message, error } = await createNewTicket(
                formData
            );
            setLoader(loading);
            if (status == "success") {
                setFormValue(initialFormValue);
                toastAlert("success", t(message), "createTicket");
                setTimeout(() => {
                    window.location.reload(false);
                }, 1500)

            } else {
                setValidateError(error);
                toastAlert("error", t(message), "createTicket");
            }
        } catch (err) {
            console.log(err, 'error')
        }
    };

    const fetchCategory = async () => {
        try {
            const { status, loading, error, result } = await getSptCat();
            if (status == "success") {
                setCategoryList(result);
            }
        } catch (err) {
            console.log(err, 'error')
        }
    };

    useEffect(() => {
        fetchCategory();
    }, []);

    return (
        <>
            <div className="dash_wrapper_flex_left">
                <div className="inner_subtitle_wrap inner_subtitle_wrap_flex mb-4">
                    <h3>{t("SUBMIT_REQUEST")}</h3>
                </div>
                <form className="assets_form">
                    <div className="mb-3">
                        <label for="Tickets" className="form-label">
                            {t("TICKET_FOR")}
                        </label>
                        <select value={categoryId}
                            name="categoryId" onChange={handleChange} placeholder={t("SELECT_CATEGORY")} className="form-select primary_asset_select">
                            <option value={""}>{t("SELECT_CATEGORY")}</option>
                            {
                                categoryList && categoryList.length > 0 && categoryList.map((item, key) => {
                                    return (
                                        <option value={item._id} key={key}>
                                            {item.categoryName}
                                        </option>
                                    )
                                })
                            }
                        </select>
                        <span className='text-danger'>{t(validateError?.categoryId)}</span>
                    </div>

                    <div className="mb-3">
                        <label for="withdrawamount" className="form-label">
                            {t("DESCRIPTION")}
                        </label>
                        <textarea
                            rows={3}
                            name="message"
                            value={message}
                            onChange={handleChange}
                            placeholder={t("ENTER_MESSAGE")}
                            className="form-control primary_asset_inp"
                        />
                        <div className="form-text ms-3">
                            {t("SUPPORT_DESCRIPTION")}
                            {/* Please enter the details of your request. A member of our
                            support staff will respond as soon as possible. */}
                        </div>
                        <span className='text-danger'>{t(validateError?.message)}</span>
                    </div>

                    <div className="mb-3">
                        <label for="withdrawamount" className="form-label">
                            {t("DOCUMENT_UPLOAD")}
                        </label>
                        <div className="custom_file_upload btn">
                            {t("UPLOAD")}
                            <input type="file" name="image" onChange={handleFileChange} />
                        </div>
                        <div className="form-text ms-1">
                            {t("UPLOAD_SIZE_RESTRICT")}
                        </div>
                        <span className='text-danger'>{t(validateError?.image)}</span>
                    </div>

                    {image?.name &&
                        <div className="uploaded_files_row">
                            <div>
                                <i className="bi bi-file-earmark-plus"></i>
                                <span>{image?.name}</span>
                            </div>
                            <div>
                                <i className="bi bi-x-circle" onClick={() => setFormValue({ ...formValue, ...{ ['image']: "" } })}></i>
                            </div>
                        </div>
                    }

                    <div className="asset_modal_btn_grp mt-5">
                        <button
                            className="w-100 primary_btn primary_btn_with_bg primary_btn_transform"
                            type="button"
                            onClick={handleFormSubmit}
                        >
                            {t("SUBMIT")}
                        </button>
                    </div>
                </form>
            </div>
        </>
    )
}

export default CreateTicket;